/**
 * Starts a drag gesture for a connector label. label.x/y are stored as an offset relative to the line midpoint.
 */
export function handleLabelMouseDown(label, midpoint, onLabelMoved, e) {
  if (e.button !== 0) return;
  e.preventDefault();
  e.stopPropagation();

  const currentAbsoluteX = midpoint.x + label.x;
  const currentAbsoluteY = midpoint.y + label.y;
  const offsetX = e.clientX - currentAbsoluteX;
  const offsetY = e.clientY - currentAbsoluteY;

  document.body.style.userSelect = 'none';
  document.body.style.cursor = 'grabbing';

  const onMouseMove = (ev) => {
    ev.stopImmediatePropagation();
    const newAbsoluteX = ev.clientX - offsetX;
    const newAbsoluteY = ev.clientY - offsetY;
    if (onLabelMoved) {
      // Convert back to a relative offset before saving.
      onLabelMoved(label.id, newAbsoluteX - midpoint.x, newAbsoluteY - midpoint.y);
    }
  };

  const onMouseUp = () => {
    document.body.style.userSelect = '';
    document.body.style.cursor = '';
    window.removeEventListener('mousemove', onMouseMove, true);
    window.removeEventListener('mouseup', onMouseUp, true);
  };

  window.addEventListener('mousemove', onMouseMove, true);
  window.addEventListener('mouseup', onMouseUp, true);
}
